<template>
  <div class="his-clamp">
    <div class="filter">
      <div class="filter-top">
        <span class="iconfont icon-shaixuan"></span>
        <span>条件筛选</span>
      </div>
      <div class="filter-content">
        <div class="area">
          <span>车身区域</span>
          <a-select
            v-model="hisClampObj.bodyAreaId"
            placeholder="请选择"
            allowClear
            @change="
              pageNumber = 1
              _getHistoryClamp()
            "
          >
            <a-select-option ref="area" v-for="item in areas" :value="item.id" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </div>
        <div class="standard">
          <span>厂家</span>
          <a-select
            v-model="hisClampObj.standardId"
            placeholder="请选择"
            allowClear
            @change="
              pageNumber = 1
              _getHistoryClamp()
            "
          >
            <a-select-option ref="standard" v-for="item in standards" :value="item.id" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </div>
        <a-input-search
          class="search"
          v-model="hisClampObj.clampName"
          placeholder="输入夹具名称"
          @change="
            pageNumber = 1
            _getHistoryClamp()
          "
        />
        <div class="tenant">
          <span>标注商户</span>
          <a-select
            v-model="hisClampObj.markTenant"
            placeholder="请选择"
            allowClear
            :options="markTenants"
            @change="
              pageNumber = 1
              _getHistoryClamp()
            "
          >
          </a-select>
        </div>
        <div class="mark-date">
          <span>标注日期 </span>
          <a-range-picker
            showTime="{ format: 'HH:mm:ss' }"
            format="YYYY-MM-DD HH:mm:ss"
            @change="
              (value, dateString) => {
                if (dateString && dateString.length > 0) {
                  hisClampObj.startTime = dateString[0]
                  hisClampObj.endTime = dateString[1]
                  pageNumber = 1
                  _getHistoryClamp()
                }
              }
            "
          />
        </div>
      </div>
    </div>
    <div class="list">
      <div class="list-top">
        <div>
          <span class="iconfont icon-a-liebiao1" />
          <span>历史夹具列表</span>
        </div>
        <div class="del" @click="_del(null)">
          <span class="iconfont icon-shanchu" />
        </div>
      </div>
      <div class="list-content">
        <a-table
          :columns="columns"
          :data-source="tableData"
          :pagination="{ total: total, current: pageNumber }"
          :row-selection="rowSelection"
          @change="_setPageNumber"
        >
          <template slot="gunFileAdress" slot-scope="text, record">
            <div v-if="!record.gunFileAddress">无</div>
            <div v-if="record.gunFileAddress">有</div>
          </template>
          <template slot="operation" slot-scope="text, record">
            <span class="iconfont icon-edit icon-bianji" @click="_edit(record)" />
            <span class="iconfont icon-switch icon-zhongxinzhuanhuan" @click="_switch(record)" />
            <a-upload
              ref="uploadGun"
              accept=""
              v-model="fileList"
              :showUploadList="false"
              class="upload"
              :customRequest="(e) => _rewriteUpload(e, record)"
            >
              <span class="iconfont icon-del icon-shangchuan" />
            </a-upload>

            <span class="iconfont icon-del icon-shanchu" @click="_del(record)" />
          </template>
        </a-table>
        <div class="all">总共{{ total }}条记录</div>
      </div>
    </div>
    <a-modal
      class="del-tip"
      centered
      :visible="isDel"
      @cancel="
        isDel = false
        ids = []
      "
      title="删除提示"
    >
      <template #footer>
        <div class="btn">
          <a-button
            class="cancel"
            @click="
              isDel = false
              ids = []
            "
            >取消</a-button
          >
          <a-button class="sure" @click="_sure">确定</a-button>
        </div>
      </template>
      <div class="content">
        <span class="iconfont icon-jingshi"></span>
        <span>此操作将删除该数据，是否继续?</span>
      </div>
    </a-modal>
    <editClamp
      v-if="isEdit"
      @closeEdit="_closeEdit"
      :rpsTypes="rpsTypes"
      :partTypes="partTypes"
      :processTypes="processTypes"
      :areas="areas"
      :standards="standards"
      :curClamp="curClamp"
      :isEdit="isEdit"
    />
  </div>
</template>
<script>
import editClamp from './edit.vue'
import { getFileByNodeId, getHistoryClampList, deleteClamp, restConvertClampNpy, addGunByHistoryClamp } from '@/api/api'
import { OssService } from '@/utils/oss/oss_service'
import { message } from 'ant-design-vue'
import { UploadFileService, EN_RESOURCE_CODE } from '@/utils/oss/upload_service.ts'
export default {
  components: {
    editClamp,
  },
  data() {
    return {
      hisClampObj: {
        bodyAreaId: undefined,
        standardId: undefined,
        clampName: null,
        markTenant: null,
        startTime: null,
        endTime: null,
      },
      areas: [],
      markTenants: [
        { label: '上海设序科技有限公司', value: '上海设序科技有限公司' },
        { label: '苏州仁欢商贸有限公司', value: '苏州仁欢商贸有限公司' },
      ],
      standards: [],
      processTypes: [],
      partTypes: [],
      rpsTypes: [],
      columns: [
        {
          title: 'id',
          dataIndex: 'clampId',
          align: 'center',
        },
        {
          title: '夹具名称',
          dataIndex: 'clampName',
          align: 'center',
        },
        {
          title: '标注时间',
          dataIndex: 'markDate',
          align: 'center',
        },
        {
          title: '标注商户',
          dataIndex: 'markTenant',
          align: 'center',
        },
        {
          title: '车身区域',
          dataIndex: 'area',
          align: 'center',
        },
        {
          title: '厂家',
          dataIndex: 'standard',
          align: 'center',
        },
        {
          title: '气缸个数',
          dataIndex: 'cylinderSize',
          align: 'center',
        },
        {
          title: '工艺类型',
          dataIndex: 'processType',
          align: 'center',
        },
        {
          title: '有无焊枪',
          dataIndex: 'gunFileAdress',
          scopedSlots: { customRender: 'gunFileAdress' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      ids: [],
      total: 0,
      pageNumber: 1,
      pageSize: 10,
      tableData: [],
      rowSelection: {
        onChange: (selectedRowKeys) => {
          this.ids = selectedRowKeys
        },
      },
      isDel: false,
      isEdit: false,
      curClamp: {},
      fileList: [],
    }
  },
  mounted() {
    this._getAreas()
    this._getProcessType()
    this._getStandards()
    this._getHistoryClamp()
    this._getpartTypes()
    this._getRpsTypes()
  },
  methods: {
    // const _onRangeChange = (value: [Dayjs, Dayjs], dateString: [string, string]) => {
    //   currentDateFilter.value = `${dateString[0]}~${dateString[1]}`;
    // };
    async _getRpsTypes() {
      const { code, result } = await getFileByNodeId({
        pageNumber: 1,
        pageSize: 99,
        resourceId: '946072328964583424',
      })
      if (code === 200) {
        this.rpsTypes = result.map(({ id, name, path, pid, rootId }) => ({ id, name, path, pid, rootId }))
      }
    },
    async _getpartTypes() {
      const { code, result } = await getFileByNodeId({
        pageNumber: 1,
        pageSize: 99,
        resourceId: '946072180972761088',
      })
      if (code === 200) {
        this.partTypes = result.map(({ id, name, path, pid, rootId }) => ({ id, name, path, pid, rootId }))
      }
    },
    async _getAreas() {
      const { code, result } = await getFileByNodeId({
        pageNumber: 1,
        pageSize: 99,
        resourceId: '946072281686388736',
      })
      if (code === 200) {
        this.areas = result.map(({ id, name, path, pid, rootId }) => ({ id, name, path, pid, rootId }))
      }
    },

    async _getStandards() {
      const { code, result } = await getFileByNodeId({
        pageNumber: 1,
        pageSize: 99,
        resourceId: '951805652257939456',
      })
      if (code === 200) {
        this.standards = result.map(({ id, name, path, pid, rootId }) => ({ id, name, path, pid, rootId }))
      }
    },
    async _getProcessType() {
      const { code, result } = await getFileByNodeId({
        pageNumber: 1,
        pageSize: 99,
        resourceId: '946074744858521600',
      })
      if (code === 200) {
        this.processTypes = result.map(({ id, name, path, pid, rootId }) => ({ id, name, path, pid, rootId }))
      }
    },
    async _getHistoryClamp() {
      const {
        code,
        data: { records, total },
      } = await getHistoryClampList({
        ...this.hisClampObj,
        page: Number(this.pageNumber),
        size: Number(this.pageSize),
      })
      if (code === 200) {
        this.total = total
        this.tableData = records.map((item) => {
          const area = this.areas.find((i) => i.id === item.bodyAreaId)
          const standard = this.standards.find((i) => i.id === item.standardId)
          const processType = this.processTypes.find((i) => i.id === item.processTypeId)
          return {
            key: item.clampId,
            processType: (processType && processType.name) || '暂无',
            standard: (standard && standard.name) || '暂无',
            area: (area && area.name) || '暂无',
            ...item,
          }
        })
      }
    },
    _del(record) {
      if (record) {
        const { key } = record
        this.ids = [...[], key]
      }
      if (this.ids.length > 0) {
        this.isDel = true
      }
    },
    // 上传焊枪
    async _rewriteUpload(data, record) {
      const { fileAddress } = await UploadFileService.uploadFile2(data.file)
      if (fileAddress) {
        const { code } = await addGunByHistoryClamp({ clampId: record.clampId, gunFileAddress: fileAddress })
        if (code === 200) {
          message.success('上传成功')
          this._getHistoryClamp()
        } else {
          message.error('上传失败')
        }
      }
    },
    async _edit(record) {
      const {
        partList,
        jsonRps,
        rpsInfo,
        clampName,
        clampId,
        bodyAreaId,
        standardId,
        cylinderSize,
        processTypeId,
        imgUrl,
        clampProductFileAddress,
        workStlFileAddress,
        workStpFileAddress,
        creator,
        createDate,
        modifier,
        modifyDate,
        matrix,
        gunGltfFileAddress,
      } = record
      const data = await OssService.downloadFromOSS(rpsInfo)
      this.curClamp = {
        partList: partList.map((item, index) => ({
          index: index + 1,
          flag: false,
          partId: item.partId,
          partName: item.partName,
          partTypeId: item.partTypeId,
          key: item.partId,
          partGlbFileAddress: item.partGlbFileAddress,
          geometryModel: item.geometryModel,
          partCatPartFileAddress: item.partCatPartFileAddress,
          matrix: item.matrix,
        })),
        rpss: data.map((item) => ({ ...item, key: item.Index, flag: false })),
        rpsInfo,
        clampName,
        clampId,
        bodyAreaId,
        standardId,
        cylinderSize,
        processTypeId,
        imgUrl: imgUrl ? `${window._CONFIG['ossPathUrl']}${imgUrl}` : '',
        clampProductFileAddress: clampProductFileAddress
          ? `${window.ENV_CONFIG.ossPrefix}${clampProductFileAddress}`
          : '',
        workStlFileAddress: workStlFileAddress ? `${window.ENV_CONFIG.ossPrefix}${workStlFileAddress}` : '',
        workStpFileAddress: workStpFileAddress ? `${window.ENV_CONFIG.ossPrefix}${workStpFileAddress}` : '',
        creator,
        createDate: createDate ? moment(createDate).format('YYYY-MM-DD HH:mm:ss') : '',
        modifier,
        modifyDate: modifyDate ? moment(modifyDate).format('YYYY-MM-DD HH:mm:ss') : '',
        matrix,
        gunGltfFileAddress,
      }
      this.isEdit = true
    },
    async _switch(record) {
      const { code, msg } = await restConvertClampNpy([record.clampId])
      if (code === 200) {
        message.success(msg)
      }
    },
    _setPageNumber(pageNumber) {
      this.pageNumber = pageNumber.current
      this._getHistoryClamp()
    },
    // 确定删除
    async _sure() {
      const { code, data } = await deleteClamp({
        historyClampIds: this.ids,
      })
      if (code === 200) {
        message.success(data)
        this.isDel = false
        this._getHistoryClamp()
      }
    },
    _closeEdit(flag) {
      this.isEdit = false
      if (flag) {
        this._getHistoryClamp()
      }
    },
  },
}
</script>
<style lang="less">
@import './index.less';
</style>
